import React from 'react';
import { dayLongLabel, monthLabel, weekDaysFor } from './AgendaResponsiveView';

function weekRangeLabel(dateStr) {
  const days = weekDaysFor(dateStr);
  const first = days[0];
  const last = days[6];
  const [, , firstDay] = first.split('-').map(Number);
  const [, , lastDay] = last.split('-').map(Number);
  return `Lun ${firstDay} - Dom ${lastDay}`;
}

export default function AgendaMobileControls({
  mode,
  setMode,
  selectedDate,
  month,
  search,
  setSearch,
  statusFilter,
  setStatusFilter,
  searchDimensions,
  activeDimensions = [],
  onToggleDimension,
  onPrev,
  onNext,
  onToday,
}) {
  return (
    <header className="agm-header">
      <div className="agm-title-row">
        <div>
          <h1>Eventos</h1>
          <p>{mode === 'month' ? monthLabel(month) : dayLongLabel(selectedDate)}</p>
        </div>
      </div>

      <div className="agm-action-row">
        <label className="agm-search-field">
          <span aria-hidden="true">⌕</span>
          <input
            type="search"
            placeholder="Buscar en toda la agenda…"
            value={search}
            onChange={event => setSearch(event.target.value)}
          />
        </label>
      </div>

      {search.trim() !== '' && searchDimensions && (
        <div className="agm-action-row ag-search-chips">
          {searchDimensions.map(dim => (
            <button
              key={dim.key}
              type="button"
              className={`ag-chip${activeDimensions.includes(dim.key) ? ' is-on' : ''}`}
              aria-pressed={activeDimensions.includes(dim.key)}
              onClick={() => onToggleDimension(dim.key)}
            >{dim.label}</button>
          ))}
        </div>
      )}

      <div className="agm-nav-row">
        <button type="button" className="agm-today-btn" onClick={onToday}>Hoy</button>

        <div className="agm-mode-toggle" role="group" aria-label="Modo de agenda">
          <button type="button" className={mode === 'week' ? 'active' : ''} onClick={() => setMode('week')}>Semana</button>
          <button type="button" className={mode === 'month' ? 'active' : ''} onClick={() => setMode('month')}>Mes</button>
        </div>

        <button type="button" className="agm-range-arrow" onClick={onPrev} aria-label="Anterior">‹</button>
        <div className="agm-range">
          <strong>{mode === 'month' ? monthLabel(month) : weekRangeLabel(selectedDate)}</strong>
          <span>{mode === 'month' ? 'solo lectura' : 'esta semana'}</span>
        </div>
        <button type="button" className="agm-range-arrow" onClick={onNext} aria-label="Siguiente">›</button>
      </div>

      <div className="agm-filter-row">
        <select value={statusFilter} onChange={event => setStatusFilter(event.target.value)}>
          <option value="todos">Todos</option>
          <option value="confirmado">Confirmado</option>
          <option value="posible">Posible</option>
          <option value="cancelado">Cancelado</option>
          <option value="pendiente">Pendiente</option>
          <option value="finalizado">Finalizado</option>
        </select>
      </div>

    </header>
  );
}
